(function(){
  'use strict';
  var initialized=false;
  function norm(value){return String(value||'').replace(/\s+/g,' ').trim()}
  function track(name,detail){
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(Object.assign({event:name},detail||{}));
  }
  function replaceText(root,from,to){
    var walker=document.createTreeWalker(root||document.body,NodeFilter.SHOW_TEXT);
    var node;
    while((node=walker.nextNode())){
      if(node.nodeValue&&node.nodeValue.indexOf(from)>-1) node.nodeValue=node.nodeValue.split(from).join(to);
    }
  }
  function fixShipping(){
    document.querySelectorAll('.template-product a[href*="policies/shipping"],.template-product .product-price a').forEach(function(link){
      var parent=link.parentElement;
      if(parent&&/versand.*bezahlvorgang|bezahlvorgang.*versand/i.test(norm(parent.textContent))){
        parent.textContent='Kostenloser Versand innerhalb Deutschlands.';
      }
    });
  }
  function fixComfortCopy(){
    if(location.pathname.indexOf('/products/bettup-ersatzmatratze-boxspringbett-boxspring-1000')===-1)return;
    replaceText(document.body,'H2 bis ca. 70 kg','H2: 60–79 kg');
    replaceText(document.body,'H3 ca. 70–100 kg','H3: 80–99 kg');
    replaceText(document.body,'H4 ab ca. 100 kg','H4: 100–120 kg');
    replaceText(document.body,'H2 bis etwa 70 kg','H2: 60–79 kg');
    replaceText(document.body,'H3 etwa 70–100 kg','H3: 80–99 kg');
    replaceText(document.body,'H4 ab etwa 100 kg','H4: 100–120 kg');
  }
  function hideNoise(){
    var selector='[id*="1747213788b358cdea"],.shopify-app-block,[class*="audien"],[id*="audien"],[class*="review"],[id*="review"]';
    document.querySelectorAll(selector).forEach(function(node){
      var text=norm(node.textContent).toLowerCase();
      var className=typeof node.className==='string'?node.className:'';
      var identifier=((node.id||'')+' '+className).toLowerCase();
      var knownAiSection=identifier.indexOf('1747213788b358cdea')>-1||!!node.closest('[id*="1747213788b358cdea"]');
      var aiPlaceholder=text.indexOf('ki-gestützte kaufberatung')>-1||text.indexOf('ki-gestutzte kaufberatung')>-1;
      var reviewWidget=/audien|review|bewertung|rezension/.test(identifier)||text.indexOf('powered by audien')>-1;
      var emptyReview=/(^|\s)(0|keine|no)\s*(bewertungen?|reviews?|rezensionen?)(\s|$)/i.test(text)||/noch keine bewertung|no reviews yet|be the first to review/i.test(text);

      if(knownAiSection||aiPlaceholder){
        var aiTarget=node.closest('[id^="shopify-section-"]')||node;
        aiTarget.classList.add('bettup-hidden-conversion-block');
        aiTarget.setAttribute('aria-hidden','true');
        return;
      }

      if(reviewWidget&&emptyReview&&text.length<220){
        node.classList.add('bettup-hidden-conversion-block');
        node.setAttribute('aria-hidden','true');
      }
    });
  }
  function highlightComfort(){
    if(!document.body.classList.contains('template-index'))return;
    document.querySelectorAll('.featured-product').forEach(function(card){
      var titles=Array.prototype.filter.call(card.querySelectorAll('.title'),function(node){
        return norm(node.textContent)==='Comfort 1000';
      });
      if(!titles.length)return;

      var badges=card.querySelectorAll('.bettup-recommendation-badge');
      var badge=badges[0];
      Array.prototype.slice.call(badges,1).forEach(function(duplicate){duplicate.remove();});

      if(!badge){
        badge=document.createElement('span');
        badge.className='bettup-recommendation-badge';
        badge.textContent='Unsere Empfehlung';
      }

      var titleWrapper=titles[0].parentNode;
      if(badge.parentNode!==titleWrapper||badge.nextSibling!==titles[0]){
        titleWrapper.insertBefore(badge,titles[0]);
      }
      card.dataset.bettupRecommended='true';
    });
    replaceText(document.body,'Maximale Stützkraft – ideal für Paare & Vielnutzer. Ab 399 €','Unser meistgewählter Kern – punktelastisch, stabil und ideal für Paare. Ab 399 €');
  }
  function nativeSubmit(){
    var buttons=Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"]'));
    return buttons.find(function(button){return !button.disabled&&button.offsetParent!==null;})||buttons[0];
  }
  function addMobileBar(){
    if(!document.body.classList.contains('template-product')||document.querySelector('.bettup-mobile-buybar'))return;
    var bar=document.createElement('div');
    bar.className='bettup-mobile-buybar';
    bar.innerHTML='<div class="bettup-mobile-buybar__copy"><strong>Auswahl übernehmen</strong><span>Kostenloser Versand in DE</span></div><button class="bettup-mobile-buybar__button" type="button">In den Warenkorb</button>';
    document.body.appendChild(bar);
    var proxy=bar.querySelector('button');
    proxy.addEventListener('click',function(){
      var source=nativeSubmit();
      if(source){track('bettup_mobile_add_to_cart_click',{product_path:location.pathname});source.click();}
      else{document.querySelector('.product-form,form[action*="/cart/add"]')?.scrollIntoView({behavior:'smooth',block:'center'});}
    });
    var source=nativeSubmit();
    if(source&&'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){bar.hidden=entries[0].isIntersecting;},{threshold:.4}).observe(source);
    }
    setInterval(function(){var current=nativeSubmit();proxy.disabled=!current||current.disabled;},800);
  }
  function trackFinder(){
    document.addEventListener('click',function(event){
      var target=event.target.closest('.bu-finder button,.bu-finder a');
      if(!target)return;
      var finder=target.closest('.bu-finder');
      if(!finder)return;
      var label=norm(target.textContent);
      if(!finder.dataset.bettupStarted){finder.dataset.bettupStarted='true';track('bettup_finder_start');}
      if(target.matches('a[href*="/products/"]')) track('bettup_finder_product_click',{label:label,href:target.href});
      if(/ergebnis|empfehlung/i.test(label)) track('bettup_finder_result_action',{label:label});
    },true);
  }
  function run(){fixShipping();fixComfortCopy();hideNoise();highlightComfort();addMobileBar();}
  function init(){
    if(initialized)return;initialized=true;
    run();trackFinder();
    [300,900,1800,3500,7000].forEach(function(delay){setTimeout(run,delay);});
    document.addEventListener('shopify:section:load',run);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
